import { rootApi } from "../../api/rootApi";

export const pincodeApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocationByPincode: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/app/pincode/" + params.pincode,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: `${params.tenant_id}`,
          },
        };
      },
    }),
    getLocationByPincodeAddress: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/app/address/pincode/" + params.pincode,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: `${params.tenant_id}`,
          },
        };
      },
    }),
    getSudamaState: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/app/address/state",
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
          },
        };
      },
    }),
    getSudamaCity: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/app/address/city?state=" + params.state,
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
          },
        };
      },
    }),
    getVoxCity: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/app/address/city" + (params.state ? "?state=" + params.state : ""),
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
          },
        };
      },
    }),
    fetchStateListV2: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/app/address/v2/state",
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
          },
        };
      },
    }),
  }),
});

export const { useGetLocationByPincodeMutation,useGetLocationByPincodeAddressMutation,useGetSudamaStateMutation,useGetSudamaCityMutation,useFetchStateListV2Mutation,useGetVoxCityMutation } = pincodeApi;

